import {api} from "./api";
import {parseHymnbookResponse} from "./apiutils";
import * as Sentry from "@sentry/browser";

export namespace Server {
    let version: string | null = null;

    export const getVersion = async () => {
        if (version) return version;

        try {
            version =  await api.server.version()
                .then(r => parseHymnbookResponse<string>(r))
        } catch (error) {
            Sentry.captureMessage("Failed to get server version")
            throw error;
        }
        return version
    }
}